import { useState, useEffect } from "react";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import Close from "@mui/icons-material/Close";
import { CircularProgress } from "@mui/material";
import { Switch } from "@mui/material";
import editIcon from "../assets/editIcon.svg";
import { RpaServices } from "../services/RpaServices";
import "./ManageRpa.scss";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
const UpdateHospitalDetailsModal = ({
  selectedUser,
  setSelectedHospitalTmsUser,
  hospitalTmsCredentials,
  setHospitalTmsCredentials,
  setSelectedUser,
  setOpen,
  setAddUserPopUpVisible,
  handleSaveChanges,
  isPasswordVisible,
  togglePasswordVisibility,
  handleApplicationChange,
  applicationIds,
  fetchHospitalList,
}) => {
  const [loading, setLoading] = useState(false);
  const [openAssignModal, setOpenAssignModal] = useState(false);
  const [applicationId, setApplicationId] = useState(
    selectedUser?.hospital?.applicationId
  );
  const handleTempAssign = async () => {
    setLoading(true);
    const data = {
      hospitalId: selectedUser?.hospital?.id,
      applicationId: applicationId,
    };
    try {
      const response = await RpaServices.assignTempDevice(data);
      window.alert(response.data.message);
      await fetchHospitalList();
      setOpen(false);
      setOpenAssignModal(false);
    } catch (error) {
      // handleApiErrorResponses(error);
      console.log(error);
      window.alert(error.response.data.error);
    }

    setLoading(false);
  };
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <div className="popup-overlay">
      <div className="popup-container relative max-h-[90%] w-[328px] xl:w-[70%] 2xl:w-[50%] bg-white rounded-[16px] p-6 xl:p-8 z-[1200]">
        <div className="w-[100%] px-5 py-2  border-gray-100 flex items-center justify-between ">
          <div className="left-10 top-6 text-xl  font-semibold text-[18px]">
            Update RPA Hospital Details
          </div>
          <div className="right-12 top-6  flex items-center gap-2 cursor-pointer">
            <div
              className="text-white text-sm bg-[#017C57] px-4 py-2 rounded-full"
              onClick={() => {
                setOpenAssignModal(true);
              }}
            >
              Temp Assign
            </div>
            <div
              className="text-white text-sm bg-[#017C57] px-4 py-2 rounded-full"
              onClick={() => {
                setAddUserPopUpVisible(true);
              }}
            >
              Add User
            </div>
            <Close
              className="font-semibold text-2xl hover:text-gray-700"
              alt="close-icon"
              onClick={() => {
                setOpen(false);
              }}
            />
          </div>
        </div>
        <div style={{ border: "1px solid #E5E5E5", marginBlock: "12px" }} />

        <div className="w-full h-[500px] flex flex-wrap justify-between  px-5 overflow-y-auto">
          <div className="w-[48%]">
            <label htmlFor="fullName" className="font-semibold block">
              UserName:
            </label>
            <input
              id="username"
              type="text"
              value={selectedUser?.fullName || ""}
              onChange={(e) =>
                setSelectedUser({
                  ...selectedUser,
                  username: e.target.value,
                })
              }
              style={{
                border: "1px solid #E4E4E4",
                marginTop: "15px",
              }}
              disabled
              className="w-full h-[40px] outline-none rounded-[8px] px-3 py-[8px]"
            />
          </div>

          <div className="w-[48%]">
            <label htmlFor="email" className="font-semibold block">
              Email:
            </label>
            <input
              id="email"
              type="text"
              value={selectedUser?.email || ""}
              onChange={(e) =>
                setSelectedUser({
                  ...selectedUser,
                  email: e.target.value,
                })
              }
              style={{
                border: "1px solid #E4E4E4",
                marginTop: "15px",
              }}
              disabled
              className="w-full h-[40px] outline-none rounded-[8px] px-3  "
            />
          </div>

          <div className="w-[48%]">
            <label htmlFor="phone" className="font-semibold block">
              Phone:
            </label>
            <input
              id="phone"
              type="text"
              value={selectedUser?.phone || ""}
              onChange={(e) =>
                setSelectedUser({
                  ...selectedUser,
                  phone: e.target.value,
                })
              }
              style={{
                border: "1px solid #E4E4E4",
                marginTop: "15px",
              }}
              disabled
              className="w-full h-[40px] outline-none rounded-[8px] px-3 py-[8px]  "
            />
          </div>

          <div className="w-[48%]">
            <label htmlFor="hospital" className="font-semibold block">
              Hospital Name:
            </label>
            <input
              id="hospital"
              type="text"
              value={selectedUser?.hospital.name || ""}
              disabled
              style={{
                border: "1px solid #E4E4E4",
                marginTop: "15px",
              }}
              className="w-full h-[40px] outline-none rounded-[8px] px-3 py-[8px]  "
            />
          </div>

          <div className="w-[48%]">
            <label htmlFor="tmsUserId" className="font-semibold block">
              TMS User Id:
            </label>
            <input
              id="tmsUserId"
              type="text"
              defaultValue={selectedUser?.hospital?.pmjayUserId || ""}
              onChange={(e) =>
                setSelectedUser({
                  ...selectedUser,
                  hospital: {
                    ...selectedUser.hospital,
                    pmjayUserId: e.target.value,
                  },
                })
              }
              style={{
                border: "1px solid #E4E4E4",
                marginTop: "15px",
              }}
              className="w-full h-[40px] outline-none rounded-[8px] px-3 py-[8px] "
            />
          </div>

          <div className="w-[48%]">
            <label htmlFor="tmsPassword" className="font-semibold block">
              TMS Password:
            </label>

            <div className="relative mt-[15px]">
              <input
                id="tmsPassword"
                type={isPasswordVisible ? "text" : "password"}
                defaultValue={selectedUser?.hospital?.pmjayPassword || ""}
                onChange={(e) =>
                  setSelectedUser({
                    ...selectedUser,
                    hospital: {
                      ...selectedUser.hospital,
                      pmjayPassword: e.target.value,
                    },
                  })
                }
                style={{ border: "1px solid #E4E4E4" }}
                className="w-full h-[40px] outline-none rounded-[8px] px-3 py-[8px]"
              />

              {isPasswordVisible === selectedUser?.hospital?.id ? (
                <VisibilityOffOutlinedIcon
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                  onClick={() =>
                    togglePasswordVisibility(selectedUser?.hospital?.id)
                  }
                  sx={{ color: "#017C57" }}
                  fontSize="small"
                />
              ) : (
                <VisibilityOutlinedIcon
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                  onClick={() =>
                    togglePasswordVisibility(selectedUser?.hospital?.id)
                  }
                  sx={{ color: "#017C57" }}
                  fontSize="small"
                />
              )}
            </div>
          </div>

          <div className="w-full grid grid-cols-5 font-medium my-1">
            <div>TMS User</div>
            <div>Alternate Number</div>
            <div>Medco App Status</div>
            <div className="text-center">Edit Info</div>
            <div className="text-center">Change Status</div>
          </div>
          <div className="w-full">
            {hospitalTmsCredentials?.map((cred, idx) => {
              return (
                <div key={idx} className="grid grid-cols-5">
                  <div>{cred.pmjayNumber}</div>
                  <div>{cred?.alternateNumber || "--"}</div>
                  <div>{cred.medicoAppStatus}</div>
                  <div
                    onClick={() => {
                      setSelectedHospitalTmsUser(cred);
                      setAddUserPopUpVisible(true);
                    }}
                    className="flex justify-center cursor-pointer"
                  >
                    <img
                      src={editIcon}
                      alt="edit-icon"
                      className="w-[18px] cursor-pointer"
                    />
                  </div>
                  <div className="flex justify-center items-start ">
                    <Switch
                      checked={cred.credentialStatus === "ACTIVE"}
                      onChange={() => {
                        if (
                          window.confirm(
                            `Are you sure you want to change status?`
                          )
                        ) {
                          const modifiedData = hospitalTmsCredentials?.map(
                            (credential) => {
                              if (credential?.id === cred?.id) {
                                return {
                                  ...cred,
                                  credentialStatus:
                                    cred.credentialStatus === "ACTIVE"
                                      ? "INACTIVE"
                                      : "ACTIVE",
                                };
                              }
                              return credential;
                            }
                          );

                          setHospitalTmsCredentials([...modifiedData]);
                        }
                      }}
                      inputProps={{ "aria-label": "toggle status" }}
                      // style={{
                      //   color: hospital?.pmjaystatus ? "#017C57" : "#B0B0B0",
                      // }}
                      style={{ color: "#017C57" }}
                      sx={{
                        "& .MuiSwitch-thumb": {
                          // backgroundColor: hospital?.pmjaystatus
                          //   ? "#017C57"
                          //   : "#D3D3D3",
                          backgroundColor: "#017C57",
                        },
                        "& .MuiSwitch-track": {
                          // backgroundColor: hospital?.pmjaystatus
                          //   ? "#017C57"
                          //   : "#D3D3D3",
                          backgroundColor: "#017C57",
                        },
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </div>

          <div className="w-[48%]">
            <label htmlFor="tmsVersion" className="font-semibold block">
              TMS Version:
            </label>
            <select
              id="tmsVersion"
              value={selectedUser?.hospital?.tmsVersion || ""}
              onChange={(e) =>
                setSelectedUser({
                  ...selectedUser,
                  hospital: {
                    ...selectedUser.hospital,
                    tmsVersion: e.target.value,
                  },
                })
              }
              className="w-full h-[40px] outline-none rounded-[8px] px-3 py-[8px] border border-[#E4E4E4] mt-[15px]"
            >
              <option value="">Select Version</option>
              <option value="1.0">1.0</option>
              <option value="2.0">2.0</option>
            </select>
          </div>

          <div className="w-[48%]">
            <label htmlFor="applicationId" className="font-semibold block">
              Application Id:
            </label>
            <select
              id="applicationId"
              value={selectedUser?.hospital?.applicationId || ""}
              onChange={handleApplicationChange}
              className="w-full h-[40px] outline-none rounded-[8px] px-3 py-[8px] border border-[#E4E4E4] mt-[15px]"
            >
              <option value="" disabled>
                Select an application
              </option>

              {applicationIds.length === 0 ? (
                <option disabled>No applications available</option>
              ) : (
                [...applicationIds]
                  .sort((a, b) => a.applicationId - b.applicationId)
                  .map((application, index) => (
                    <option key={index} value={application.applicationId}>
                      {application.applicationId + "-" + application.ownerName}
                    </option>
                  ))
              )}
            </select>
          </div>
        </div>
        <div className="flex justify-center ">
          <div className="text-white text-xs font-semibold bg-[#017C57] rounded-full py-1 px-2 cursor-pointer">
            <button onClick={handleSaveChanges} className="save-button">
              Save Changes
            </button>
          </div>
        </div>
      </div>

      {openAssignModal && (
        <div className="fixed top-0 left-0 h-screen w-screen bg-[#017C5780] z-[1201] flex justify-center items-center">
          <div className="relative w-[40%]  h-fit bg-white  px-10 py-5 rounded-[20px]">
            <div
              className="absolute top-2 right-5 cursor-pointer"
              onClick={() => setOpenAssignModal(false)}
            >
              <Close />
            </div>
            <div className="flex justify-between items-center">
              <label htmlFor="applicationId" className="font-semibold block">
                Application Id:
              </label>
              <select
                id="applicationId"
                value={applicationId || ""}
                onChange={(e) => setApplicationId(e.target.value)}
                className="w-[48%] h-[40px] outline-none rounded-[8px] px-3 py-[8px] border border-[#E4E4E4] mt-[15px]"
              >
                <option value="" disabled>
                  Select an application
                </option>

                {applicationIds.length === 0 ? (
                  <option disabled>No applications available</option>
                ) : (
                  [...applicationIds]
                    .sort((a, b) => a.applicationId - b.applicationId)
                    .map((application, index) => (
                      <option key={index} value={application.applicationId}>
                        {application.applicationId +
                          "-" +
                          application.ownerName}
                      </option>
                    ))
                )}
              </select>
            </div>
            <div className="flex justify-center items-center mt-4">
              {loading ? (
                <CircularProgress />
              ) : (
                <div
                  className="text-sm font-semibold text-white bg-[#017C57] px-10 py-3 rounded-full cursor-pointer"
                  onClick={handleTempAssign}
                >
                  SAVE
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateHospitalDetailsModal;
